import {type RouteLocation, type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const PageList     = () => import('../views/page/PageList.vue');
const PageView     = () => import('../views/page/PageView.vue');
const PageEdit     = () => import('../views/page/PageEdit.vue');
const FolderEdit   = () => import('../views/page/FolderEdit.vue');
const PageSettings = () => import('../views/page/PageSettings.vue');

let meta: MetaData = {module: 'page'};

let page: RouteRecordRaw[] = [
    {
        path: '/page',
        redirect: {name: 'page-list'},
        meta,
    },
    {
        path: '/page/list',
        name: 'page-list',
        component: PageList,
        props()
        {
            return {folder: 0};
        },
        meta,
    },
    {
        path: '/page/settings',
        name: 'page-settings',
        component: PageSettings,
        meta,
    },
    {
        path: '/page/list/folder/:folder/:wildcard*',
        name: 'folder-list',
        component: PageList,
        props(route: RouteLocationStringParam)
        {
            return {folder: parseInt(route.params.folder)};
        },
        meta,
    },
    {
        path: '/folder/add/parent/:parent',
        name: 'folder-add',
        component: FolderEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: 0,
                parent: parseInt(route.params.parent),
            };
        },
        meta,
    },
    {
        path: '/folder/edit/id/:id/parent/:parent/:wildcard*',
        name: 'folder-edit',
        component: FolderEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                parent: parseInt(route.params.parent),
            };
        },
        meta,
    },
    {
        path: '/page/add/folder/:folder',
        name: 'page-add',
        component: PageEdit,
        props(route: RouteLocationStringParam)
        {
            return {folder: parseInt(route.params.folder)};
        },
        meta,
    },
    {
        path: '/page/edit/id/:id/folder/:folder/:wildcard*',
        name: 'page-edit',
        component: PageEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                folder: parseInt(route.params.folder),
            };
        },
        meta,
    },
    {
        path: '/page/edit/copy/:copy/folder/:folder/:wildcard*',
        name: 'page-copy',
        component: PageEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                copy: parseInt(route.params.copy),
                folder: parseInt(route.params.folder),
            };
        },
        meta,
    },
    {
        path: '/page/view/id/:id/:wildcard*',
        name: 'page-view',
        component: PageView,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id)};
        },
        meta,
    },
    // COMPATIBILITY: OLD PATHS
    {
        path: '/page/index/index',
        redirect: {name: 'page-list'},
        meta,
    },
    {
        path: '/page/index/list',
        redirect: {name: 'page-list'},
        meta,
    },
    {
        path: '/page/edit',
        redirect: {
            name: 'page-add',
            params: {folder: '0'},
        },
        meta,
    },
    {
        path: '/folder/edit',
        redirect: {
            name: 'folder-add',
            params: {parent: '0'},
        },
        meta,
    },
    {
        path: '/page/index/list/folder/:folder/:wildcard*',
        redirect: (route: RouteLocation) =>
        {
            return {
                name: 'folder-list',
                params: {
                    folder: parseInt(route.params.folder as string),
                },
            };
        },
        meta,
    },
    {
        path: '/page/index/view/id/:id/:wildcard*',
        redirect: (route: RouteLocation) =>
        {
            return {
                name: 'page-view',
                params: {
                    id: parseInt(route.params.id as string),
                },
            };
        },
        meta,
    },
    {
        path: '/page/:wildcard*',
        redirect: {name: 'page-list'},
        meta,

    },
];

export default page;
